import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue from 'vue'
import { Promise } from 'es6-promise' // 引入Promise
// import store from '@/store/index'
// import router from '@/router/index'

Vue.use(VueAxios, axios)

axios.defaults.timeout = 20000
// 默认的请求连接
// export const BaseURL = 'http://123.57.62.160:8085/official/'
// export const BaseURL = 'http://127.0.0.1:8085/official/'
// export const BaseURL = 'http://47.102.202.171:19008/official/'
// export const BaseURL = 'https://dasoundgen.com/api/official/'

let url = window.location.href
let reg = /^http:.*/
let ishttp = ''
if (reg.test(url)) {
  ishttp = 'http://47.102.202.171:19008/official/'
} else {
  ishttp = 'https://dasoundgen.com/api/official/'
}
export const BaseURL = ishttp
axios.defaults.baseURL = BaseURL
axios.defaults.withCredentials = true
/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (
  url,
  data = {},
  config = {
    headers: {
      'Content-Type': 'application/json'
      //   accessToken: store.getters.accessToken
    }
  }
) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, config).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err.response)
      }
    )
  })
}

/**
 * filePost 请求方法
 * @param url
 * @param filedata
 * @returns {Promise}
 */
export function filePost (
  url,
  data = {},
  config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
) {
  return new Promise((resolve, reject) => {
    console.log('config')
    console.log(config)
    axios.post(url, data, config).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err.response)
      }
    )
  })
}

axios.interceptors.response.use(response => {
  return response
}, error => {
  console.log(error.response)
  return Promise.reject(error.response.data)
})

export function get (
  url,
  data = {},
  config = {
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': 'text/json'
      //   accessToken: store.getters.accessToken
    }
  }
) {
  return new Promise((resolve, reject) => {
    axios.get(url, data, config).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err.response)
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/api/http.js